import { get, post, patch } from "./http";

export const login = async ({ email, password }) => {
  const jsonData = await post("/authentication/", { username: email, password });
  let token;
  if (jsonData) {
    if (jsonData.error) {
      console.error("Login error :", jsonData.error);
    } else {
      token = jsonData.data.token;
    }
  }
  return token;
};

export const signup = async (data) => {
  const jsonData = await post("/account/customer/", data);
  return jsonData;
};

export const resetPassword = async (data) => {
  const jsonData = await post("/account/resetpasswordconfirm/", data);
  return jsonData;
};

export const sendResetEmail = async ({ email }) => {
  const jsonData = await post("/account/resetpassword/", { email });
  return jsonData;
};

export const getUser = async (token) => {
  const jsonData = await get("/account/customer/me/", token);
  let currentUser;
  if (jsonData) {
    if (jsonData.error) {
      console.error("getUser error :", jsonData.error);
    } else {
      currentUser = {
        id: jsonData.id,
        last_name: jsonData.last_name,
        first_name: jsonData.first_name,
        email: jsonData.email,
        email_hash: jsonData.email_hash,
        phone: jsonData.phone,
      };
    }
  }
  return currentUser;
};

export const editUserData = async (data, token) => {
  const jsonData = await patch("/account/customer/me/", data, token);
  return jsonData;
};

export const checkEmail = async (email) => {
  const jsonData = await post("/account/customercheck/", { email });
  return jsonData;
};
